import { Company } from "@finway-group/shared/lib/models"

export const companyData: Company = {
    name: "Finway GmbH",
    iban: "DE89 3704 0044 0532 0130 00",
    bic: "DABAIE2D",
    defaultCreditorNumber: 800,
} as Company
